import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const TableFoot = ({count, filter, setFilter}) => {

    return(
        <div className="table-footer">
            <div className='table-limiter'>
                <span>Per Page:</span>
                <select className='form-control' style={{maxWidth: "80px"}} value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
            <Stack spacing={2}>
                <Pagination showFirstButton showLastButton onChange={(e) => setFilter((prev) => ({...prev, page: e.target.innerText}))} count={count} color="primary" variant="outlined" shape="rounded" />
            </Stack>
        </div>
    )
}

export default TableFoot